export default __webpack_public_path__ + "locales/pt/UploadPanel.json?hash=ae1b21b34fd277bed63b41ea30fa4dfc";